import createAction from '../services/create-action';

export const STOP_EDITING_COMMENT = 'comment/STOP_EDITING';
export const stopEditingComment = createAction(STOP_EDITING_COMMENT);



// WEBPACK FOOTER //
// ./app/actions/stop-editing-comment.js